import { render, staticRenderFns } from "./YpoResources.vue?vue&type=template&id=0dcab64c&scoped=true&"
import script from "./YpoResources.vue?vue&type=script&lang=js&"
export * from "./YpoResources.vue?vue&type=script&lang=js&"
import style0 from "./YpoResources.vue?vue&type=style&index=0&id=0dcab64c&lang=scss&scoped=true&"
import style1 from "./YpoResources.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcab64c",
  null
  
)

export default component.exports